import React from "react";


const ParticipantListComboBox = (props) => {
    if (props.participants.length === 0) {
        return null;
    }

    return (
        <div className="mt-3 ml-8 mr-8 h-60 overflow-y-auto border border-gray-900 pl-6 pt-2">
            {props.participants.map((participant, index) => {
                if (participant === undefined) { return ''; }
                return (
                    <p key={`participant-${index}`}>{participant.displayName}</p>
                )
            })}
        </div>
    );
}

export default ParticipantListComboBox;